<template>
  <div>
    <div class="centerx">
      <vs-popup
        class="holamundo"
        v-bind:title="'Ajuda - Cadastro da mão de obra'"
        :active.sync="popupActivo"
      >
        <div v-html="textoAjuda"></div>
      </vs-popup>
    </div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">{{nome}}</h4>
      <div
        class="badge bagde-default"
        @click="popupActivo = true"
        style="position: absolute; top: 17px; right: 15px"
      >
        Ajuda <i class="fa fa-question-circle"></i>
      </div>
    </div>
    <div class="card">
      <form style="padding:15px;" autocomplete="off" > 
        <h4 class="mb-3">Benefícios</h4>
        <div class="form-row">
          <div class="form-group col-md-3">
             <label for="_form-periodo">Benefício</label>

              <vs-select
                id="_form-periodo"
                placeholder="Selecione a função"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.beneficioId"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.beneficioId" :text="item.titulo" v-for="(item,index) in beneficios" />
              </vs-select>    

          </div>
        <div class="form-group col-md-3" v-if="cadastro.beneficioId == 0">
                <label>Outro</label>
                <input type="text" name="outrobeneficio" v-model="outrobeneficio" class="form-control">
          </div>
        <div class="form-group col-md-3">
           <label for="_form-valor">Valor</label>
           <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.valor"
              id="_form-valor"
              required
              currency="R$"
              v-bind:precision="2"
              separator="."
           />
        </div>
        <div class="col-sm-12">
          <hr>
        </div>
        </div>
           <div style="display: flex; justify-content:space-between">
            <router-link :to="`/areacliente/contrato/etapa5/${this.$route.params.codigoContrato}`" tag="button" class="btn btn-danger mr-auto">Voltar</router-link>
            <button class="btn btn-primary ml-auto" @click.prevent="fnCadastra">Salvar</button>
          </div>
      </form>  
      <div style="padding:15px;">
          <vs-table
            :data="content">
            <template slot="header" >
              <h3>
                Registros
              </h3>
            </template>
            <template slot="thead">
              <vs-th :style="'width:'+iconArea+'px'">
                Ações
              </vs-th>
              <vs-th>
                Benefício
              </vs-th>
              <vs-th  class="text-right txt" style="width:150px;">
                <div class="text-right" > Valor</div>
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td>
                <a
                class="icone-editar"
                data-editar
                @click="fnEditar(indextr)"
                title="Editar"
                >
                    <i class="i-circled i-small i-light icon-line-edit"></i>
                </a>
                  <a
                  class="icone-editar"
                  data-deletar
                  @click="fnDeletar(tr.etapaBId)"
                  title="Deletar"
                  >
                      <i class="i-circled i-small i-light icon-trash" ></i>
                  </a>
               </vs-td>
                <vs-td :data="fnConcat(tr.beneficioId)">
                  {{fnConcat(tr.beneficioId)}}
                </vs-td>
                <vs-td class="text-right" :data="tr.valor">
                  R$ {{formataPrice(tr.valor)}}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { getSuccess,formatPrice,clientKey } from "../../../global/utils";

  export default {
    data() {
      return {
        content:[],
        cadastro:{
        } ,
        beneficios:{},
        incluindo:false,
        iconArea: 45 * 2,
        titulo:'',
        tipo:'',
        nome:'',
       servico: null,
      textoAjuda: null,
      popupActivo: false,
       cadastroid:null,
       outrobeneficio: ""
      }
    },
    mounted() {
      this.fnGetContratacao()
      this.fnGetFuncao()
    },
    methods: {
      async fnGetFuncao(){
        await this.$http.get('listabeneficios/api/')
        .then(res=> {
          this.beneficios = res.data;
          this.beneficios.push({beneficioId:0, titulo:"Outros"})
        })
        .catch(()=>{})
    },
    formataPrice(val){
      return formatPrice(val)
    },
      async fnCadastra(e) {
        e.preventDefault();
        console.log(this.cadastro.etapaBId)
        const metodo = this.cadastro.etapaBId ? "put" : "post";
        this.cadastro.tsAlteracao = this.cadastro.etapaBId
          ? this.$moment().format()
          : null;
        const completaUrl = this.cadastro.etapaBId
          ? "/" + this.cadastro.etapaBId 
          : "/" + this.cadastroid;
        let headers = {
        'outrobeneficio': this.outrobeneficio,
      };

        await this.$http[metodo]("/etapa_05B" + completaUrl + "?outrobeneficio="+this.outrobeneficio, this.cadastro,{headers:headers})
          .then((res) => {
            if ( metodo == "post"){this.content.push(res.data)} 
            getSuccess();
            this.cadastro ={
              etapaId: parseInt(this.$route.params.etapaId)

            }
          window.location.reload(true);

          })
          .catch(() => {});
      },    

      async fnGetContratacao() {
        await this.$http
          .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_05`)
          .then((res) => {
            console.log(res.data.contratacaoId);
            this.cadastro.etapaId = parseInt(this.$route.params.etapaId)
            this.cadastroid = res.data.contratacaoId

            if(res.data.contratacoesEVO05 != null){
              let data = res.data.contratacoesEVO05
              //let content = []

              var item = data.filter((administracoes) => {
                return administracoes.etapaId ==this.$route.params.etapaId
              });
              this.nome = item[0].nome
              for(var i =0; i < item[0].contratacoesEVO05B.length;i++){
                this.content.push(item[0].contratacoesEVO05B[i])
              }
            }
          })
          .catch(() => {});
       await this.$http
        .get(`contratacao/lista/${this.$route.params.codigoContrato}`)
        .then((res) => {
          this.servico = res.data.servicos;
          this.textoAjuda = this.servico.textoAjuda05;
        });
     },
      fnCancela(){
        this.incluindo = false;
        this.titulo = ''
        this.tipo =''

      },
      fnEdicao(val){
        if (val == 'Incluindo'){
          this.incluindo = true;
          this.titulo = 'Incluindo novo registro'
          this.tipo ='Inclusão'
        }
      },
      fnEditar(i){
       this.cadastro = this.content[i]
        },
      fnConcat(val){
        var item = this.beneficios.filter((administracoes) => {
          return administracoes.beneficioId ==val
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
        convertToken(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
        },
    async fnDeletar(val) {

        var token = localStorage.getItem(clientKey)
        var dataToken = this.convertToken(token)
      await this.$http.delete(`/etapa_05B/${val}/${dataToken.ClienteId}/${this.cadastroid}`)
        .then(() => {
          let i = this.content.map(item => item.etapaBId).indexOf(val) 
          this.content.splice(i, 1)
          getSuccess();
        })
        .catch(() => {});
    },
    

    },
  }
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user{
  width: 100%;
}
form{
  margin-bottom:0 !important;
}
</style>